import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { client, setAccessToken } from './client';
import type { User } from '../types';

interface LoginResponse {
  accessToken: string;
  user: User;
}

interface AcceptInviteResponse {
  accessToken: string;
  user: User;
}

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ login, password }: { login: string; password: string }) =>
      client.post<LoginResponse>('/auth/login', { login, password }),
    onSuccess: (data) => {
      setAccessToken(data.data.accessToken);
      queryClient.setQueryData(['auth', 'me'], data.data.user);
    },
  });
}

export function useAcceptInvite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { token: string; login: string; password: string }) =>
      client.post<AcceptInviteResponse>('/auth/accept-invite', params),
    onSuccess: (data) => {
      setAccessToken(data.data.accessToken);
      queryClient.setQueryData(['auth', 'me'], data.data.user);
    },
  });
}

export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => client.get<{ user: User }>('/auth/me').then((r) => r.data.user),
    retry: false,
    staleTime: Infinity,
  });
}

export function useLogout(): () => Promise<void> {
  const queryClient = useQueryClient();
  return async (): Promise<void> => {
    try {
      await client.post('/auth/logout');
    } catch {
      // Logout должен работать даже если сервер недоступен
    }
    setAccessToken(null);
    queryClient.clear();
    window.location.href = '/login';
  };
}
